export default __webpack_public_path__ + "static/media/sandstone_256x256.71e91283.png";